export default __webpack_public_path__ + "static/media/floor2.0bfa1c1e.svg";